module.exports = __webpack_public_path__ + "static/media/pin_registration.acbd7ff5.jpg";